// 3rd party imports
import * as React from 'react';

// bernie
import { ContextStore } from 'bernie-core';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// mobx
import { Quicklink } from 'models';

// ui
import { UitkIcon } from 'uitk-react-icons';
import { UitkCard } from 'uitk-react-cards';
import { UitkFakeInput } from 'uitk-react-input';
import { UitkLink } from 'uitk-react-link';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';

import { CopyButton } from './copy-button';

export const ConfiguredQuicklink: React.FunctionComponent<Quicklink> = (props) => {
  return (
    <UitkSpacing margin={{ blockend: 'four' }}>
      <UitkCard padded={true}>
        <UitkLayoutGrid columns={{ small: 1, large: 4 }} space="four">
          <>
            <UitkLayoutGridItem colSpan={{ small: 1, large: 1 }}>
              <div>
                <UitkHeading tag="h2" size={5}>
                  {props.title}
                </UitkHeading>
                <UitkLink inline={true}>
                  <a target="_blank" href={props.link}>
                    Preview
                    <UitkIcon name="open_in_new" />
                  </a>
                </UitkLink>
              </div>
            </UitkLayoutGridItem>
            <UitkLayoutGridItem colSpan={{ small: 1, large: 3 }}>
              <UitkLayoutGrid columns={{ small: 1, large: 2 }} space="four">
                <UitkLayoutGridItem>
                  <UitkLayoutFlex space="two" className="QuicklinkInputs">
                    <UitkFakeInput id="one" label="Link" value={props.pzLink} />
                    <CopyButton value={props.pzLink} />
                  </UitkLayoutFlex>
                </UitkLayoutGridItem>
                <UitkLayoutGridItem>
                  <UitkLayoutFlex space="two" className="QuicklinkInputs">
                    <UitkFakeInput id="one" label="Code" value={props.code} />
                    <CopyButton value={props.code} />
                  </UitkLayoutFlex>
                </UitkLayoutGridItem>
              </UitkLayoutGrid>
            </UitkLayoutGridItem>
          </>
        </UitkLayoutGrid>
      </UitkCard>
    </UitkSpacing>
  );
};
